module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button",
    class: _vm.color + ' ' + _vm.size,
    style: ('top:' + _vm.top + 'px;' + 'left:' + _vm.left + 'px')
  }, [_c('i', {
    class: {
      'active': _vm.active
    }
  }), _vm._v(" "), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.size === 's1'),
      expression: "size==='s1'"
    }],
    style: ('transform:' + _vm.arrow + ' scale(1,2)')
  }), _vm._v(" "), _c('span', {
    class: _vm.position ? 'position' : ''
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-669355c0","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/keyboard/button/index.vue
// module id = 141
// module chunks = 1